<template>
  <input :value="formattedEngravedId"
         class="filter"
         maxlength="19"
         @input="normalizeEngravedIdAndTriggerEvent">
</template>

<script>
export default {
  name: 'EngravedId',
  props: {
    rawEngravedId: {
      type: String,
      required: true
    }
  },
  computed: {
    formattedEngravedId () {
      const engravedIdParts = this.rawEngravedId.match(/.{1,4}/g)

      return engravedIdParts !== null ? engravedIdParts.join('.') : ''
    }
  },
  methods: {
    normalizeEngravedIdAndTriggerEvent (event) {
      let value = event.target.value.replace(/[^0-9]/g, '')

      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tableHeaderSearch/fields/EngravedId.vue